 import shortUUID from "short-uuid";
import { defaultDimensions, otherDisplayTypes, uiTypeChildren } from "../../config/fields";
import isEqual from 'lodash.isequal';
import { counterTypes, stringTypes } from "../../config/common";


export const arrayMove = function (arr, oldIndex, newIndex) {
	const copiedArr = [...arr];
	const length = copiedArr.length;

	if (oldIndex !== newIndex && length > oldIndex && length > newIndex) {
		copiedArr.splice(newIndex, 0, copiedArr.splice(oldIndex, 1)[0]);
	}

	return copiedArr;
}

export const findSelectedSchema = ({ schemas, id }) => {
	try {
		
	if (!schemas || !id) return null;
	function flatten(array, currentArray) {
		if (!array) return currentArray;

		return [...array.flatMap((currentElement) => {
			const { children, ...element } = currentElement;
			return [{ children, ...element }, ...flatten(children, [])];
		}), ...currentArray];
	}

	const sections = flatten(JSON.parse(JSON.stringify(schemas)), [])

	const selectedSchema = sections.find(item => item.id === id)
	return selectedSchema;


	} catch (error) {
		console.error(`Finding selected schema failed. ${error}`);
		console.log({schemas, id})		
		return null;
	}
}

export const findSelectedAction = ({ schemas, id, actionId }) => {
	// console.log({ schemas, id })
	function flatten(array, currentArray) {
		if (!array) return currentArray;

		return [...array.flatMap((currentElement) => {
			const { children, ...element } = currentElement;
			return [{ children, ...element }, ...flatten(children, [])];
		}), ...currentArray];
	}

	const sections = flatten(schemas, [])

	const selectedSchema = sections.find(item => item.id === id)

	return selectedSchema;

}

const updateMappingObject = ({mapping, data}) => {
	// console.log("------updateMappingObject---------")
	// console.log({mapping})

	const id = data?.id
	
	if(data?.id) delete data?.id
	if(data?.name) delete data?.name
	if(data?.mapping) delete data?.mapping
	// console.log({data})
	
	if(mapping?.extensions === undefined) mapping.extensions = []

	let fieldInExtension = mapping?.extensions?.find(item => item?.parent === id)
	// console.log({fieldInExtension})

	if(fieldInExtension != undefined){
		mapping.extensions = mapping.extensions?.map(item => {
			if(item?.parent === id){
				item.attributes = data
			}
			return item;
		} )
	}else{
		mapping.extensions.push({
			parent: id,
			attributes: data
		})
	}
	
	return mapping
}


export const editSection = ({ schemas, sectionData, children, fromUndoRedo, parentId, isParentMappedFromClusterlet }) => {
	
	const sections = JSON.parse(JSON.stringify(schemas));
	let updated = "";

	const updateSection = (id, obj, schemas) => {

		for (var i = 0; i < schemas.length; i++) {
			// console.log("item------", schemas[i]?.id, schemas[i]?.name)

			if(sectionData?.viewCopy === true && parentId != undefined && parentId != "" && parentId != false ){
				if(schemas[i]?.id === parentId){
					console.log("parent found to update mapping: ", schemas[i])
					schemas[i] = {
						...schemas[i],
						mapping: updateMappingObject({mapping: schemas[i]?.mapping, data: sectionData})
					}

					console.log("new mapping obj: ", schemas[i]?.mapping)
				} else {
					if (schemas[i].children) updateSection(id, obj, schemas[i].children)
				}
			}else{
				if (schemas[i].id == id) {
					schemas[i] = {
						...obj,
						children: children === undefined ? [] : children.length > 0 ? children : schemas[i].children
					}
	
					//if from undo-redo edit, take the children
					if (fromUndoRedo) schemas[i].children = children;
	
				} else {
					if (schemas[i].children) updateSection(id, obj, schemas[i].children)
				}
			}

			
		}
		return schemas

	}

	sections.forEach(item => {
		const newArray = [item]
		const sectionArray = JSON.parse(JSON.stringify(newArray))

		const updatedSchema = updateSection(sectionData.id, sectionData, newArray)
		const updatedSchemaArray = JSON.parse(JSON.stringify(updatedSchema))

		const isEqualArray = isEqual(sectionArray, updatedSchemaArray);

		/**if not equal, then update has been made, return the object */
		if (isEqualArray === false) updated = updatedSchemaArray[0]
	})

	return updated;
}

export const addNestedSection = ({ schemas, parentID, section, index }) => {

	// console.log("adddd", { schemas, parentID, section, })

	const sections = JSON.parse(JSON.stringify(schemas));
	let updated = "";
	const updateSection = (id, obj, schemas) => {
		for (var i = 0; i < schemas.length; i++) {
			if (schemas[i].id == id) {
				let schema = schemas[i].children;
				let elementindex = index === undefined ? schema.length : index;
				schema.splice(elementindex, 0, section);  //for adding to right position when doing undo
				schemas[i].children = schema;
			} else {
				if (schemas[i].children) updateSection(id, obj, schemas[i].children)
			}
		}
		return schemas;
	}

	sections.forEach(item => {

		const newArray = [item]
		const sectionArray = JSON.parse(JSON.stringify(newArray))

		const updatedSchema = updateSection(parentID, section, newArray)
		const updatedSchemaArray = JSON.parse(JSON.stringify(updatedSchema))

		const isEqualArray = isEqual(sectionArray, updatedSchemaArray);

		/**if not equal, then update has been made, return the object */
		if (isEqualArray === false) updated = updatedSchemaArray[0]
	})

	return updated;
}

export const deleteSchemaItem = (parentID, section, schema) => {

	try {
		let deletedItem = "";
		let index;

		const deleteItem = (parentID, section, schema) => {

			for (var i = 0; i < schema.length; i++) {
				if (schema[i].id === section) {
					deletedItem = schema[i];
					schema.splice(i, 1);
					index = i;
				}
				else {
					if (schema[i].children) deleteItem(parentID, section, schema[i].children)
				}
			}
			return schema;
		}

		const deleteResult = deleteItem(parentID, section, schema)
		const finalSchema = JSON.parse(JSON.stringify(deleteResult));

		return { deletedItem, finalSchema, index }

	}
	catch (error) {
		return null;
	}

}

export const convertToTreeFormat = (treeData) => {

	const tree = (data) => {

		for (var i = 0; i < data?.length; i++) {

			data[i].title = data[i].title ? data[i].title : data[i].name;
			if (data[i].children) tree(data[i].children);

		}
		return treeData;
	}

	const treeFormat = tree(treeData)

	return treeFormat;
}

export const filterNodesByType = (node) => {
	// Check if the node has a 'type' attribute and it equals 'drop-down'
	return !node.type || node.type !== 'drop-down';
}

// Function to filter nodes recursively
export const filterTree = (tree) => {
	return tree.filter((node) => {
		// If the node has children, filter them recursively
		if (node.children && node.children.length > 0) {
			node.children = filterTree(node.children);
		}
		return filterNodesByType(node);
	});
}

/**to find section names in the same level */
export const findExistingSectNames = ({ schemas, id, action, rootId }) => {
	try {
	let existingSectionNames = [];
	const findExistingSectionNames = ({ schemas, id, action }) => {
		schemas.forEach(schema => {

			if (schema.id === id) {

				if (action === 'edit')
					existingSectionNames.push(...schemas.filter(item => item.id !== schema.id).map(item => item.name));

				if (action === 'create') {
					existingSectionNames.push(...schema.children.map(item => item.name));
				}

			} else {
				if (schema.children)
					findExistingSectionNames({ id, schemas: schema.children, action })
			}
		})

	}

	findExistingSectionNames({ schemas, id, action })

	if (action === 'create' && rootId === id)
		existingSectionNames = schemas.map(item => item.name)

	return existingSectionNames;
	} catch (error) {
		console.error(`Finding existing section names failed. ${error}`);
		console.log({schemas, id, action});
		return [];
	}
}


export const findImmediateParent = (schema, selectedItemId) => {

	try {

		let parentData = {};

		const findParent = (schema, itemId) => {

			for (var i = 0; i < schema.length; i++) {

				if (schema[i].children.some(child => child.id == itemId)) {
					parentData = {
						id: schema[i].id,
						type: schema[i].type
					}
				}
				else {
					if (schema[i].children) findParent(schema[i].children, itemId)
				}
			}

			return parentData
		}

		const parentInfo = findParent(schema, selectedItemId)
		return parentInfo
	}
	catch (error) {
		return null
	}

}

export const removeKeyFromTree = (array, key) => {
	try {

		const arrayJson = JSON.parse(JSON.stringify(array));

		const deleteProperty = (array, key) => {

			for (var i = 0; i < array.length; i++) {

				if (array[i].id !== null) {
					if (array[i].hasOwnProperty(key)) {
						const { [key]: _, ...objRest } = array[i];
						array[i] = {
							...objRest
						}
					}
				}
				else {
					if (array[i].children) deleteProperty(array[i].children, key)
				}
			}

			return array;
		}
		const newArray = deleteProperty(arrayJson, key)
		return newArray

	}
	catch (error) {
		return null
	}
}

/**reverse traversal of tree*/
function findNodesToExpand(inputId, childArray) {
	if (!childArray) { return }
	for (const parent of childArray) {
		if (parent.id === inputId) {
			return [parent.id]
		} else {
			let res = findNodesToExpand(inputId, parent.children)
			if (res) {
				res.push(parent.id)
				return res
			}
		}
	}
	return
}

export const expandTree = (id, tree) => {


	let expandIds = findNodesToExpand(id, tree)

	const addExpandKey = (expandIds, tree) => {

		if (expandIds === undefined) return tree;

		for (var i = 0; i < tree.length; i++) {

			if (expandIds.includes(tree[i].id)) tree[i].expanded = true;

			if (tree[i].children && tree[i].children[0] !== null) addExpandKey(expandIds, tree[i].children)

		}
		return tree
	}

	const stringifiedTree = JSON.parse(JSON.stringify(tree))
	const expandedTree = addExpandKey(expandIds, stringifiedTree)
	return expandedTree;
}

export const getChildFromTree = (array, nodeId) => {

	try {

		let child = {};

		const getChild = (array, nodeId) => {
			for (var i = 0; i < array.length; i++) {
				if (array[i].id === nodeId) {
					child = array[i];
				}
				else {
					if (array[i].children) getChild(array[i].children, nodeId)
				}
			}

			return child;
		}

		const childFromTree = getChild(array, nodeId);
		return childFromTree;
	}
	catch (error) {
		return null;
	}


}


export const findundoRedoItem = ({ schemas, item }) => {

	let original = ""
	let index;
	const findItem = (schemas, item) => {

		for (var i = 0; i < schemas.length; i++) {

			if (schemas[i].id === item.id) {
				original = schemas[i];
				index = i;
			}
			if (schemas[i].children) findItem(schemas[i].children, item)

		}
	}

	findItem(schemas, item);

	return { original, index }
}



export const changeUuidsForSchema = (schema) => {

	const sections = JSON.parse(JSON.stringify(schema))

	function loop(obj) {
		if (typeof obj !== 'object') return;
		Object.keys(obj).forEach((k) => {
			if (k === 'id') obj[k] = shortUUID.generate();
			else loop(obj[k]);
		});
	}

	sections.forEach(element => {
		loop(element)
	});


	return sections;
}

export const changeUuidsForObj = (payload) => {

	const obj = JSON.parse(JSON.stringify(payload))

	function loop(obj) {
		if (typeof obj !== 'object') return;
		Object.keys(obj).forEach((k) => {
			if (k === 'id') obj[k] = shortUUID.generate();
			else loop(obj[k]);
		});
	}

	loop(obj)

	return obj
}


export const formatExtendedFields = (originalArray, extendedArray) => {

	try {

		const resultArray = [];
		const notFoundArray = [];

		// Create a map of names to original elements for faster lookup
		const originalMap = new Map(originalArray.map(item => [item.name, item]));

		for (const extendedItem of extendedArray) {
			const originalItem = originalMap.get(extendedItem.name);

			if (originalItem) {
				// Check if the original element has children and process recursively
				if (originalItem.children && originalItem.children.length > 0) {
					extendedItem.children = formatExtendedFields(originalItem.children, extendedItem.children);
				}

				// Add _id from original element
				extendedItem._id = originalItem._id;

				let alreadyExist = resultArray.find(item => item.name == extendedItem.name)

				if (alreadyExist == undefined) resultArray.push(extendedItem);

				// Add extended element to the result array

			} else {
				// If the name is not found in the original array, add it to the not found array
				notFoundArray.push(extendedItem.name);
			}
		}

		return { resultArray, notFoundArray };

	}
	catch (error) {

		return null
	}
}



const sectionAsChildrenNodes = ["clusterlet", "analytics", "sensor"]
const fieldAsChildrenNodes = ["message", "user_trigger", "section"]

const deletePropertyRecursivly = (payload) => {
	try {
		const { node, key } = payload
		if (node[key]) delete node[key]

		node?.children?.forEach(child => deletePropertyRecursivly({ node: child, key: "parent" }))

	} catch (error) {
		console.error(error)			
	}
}

const findChildrenNodes = (node, sections, fields) => {
	try {
	  // console.log("findChildren", {node, sections, fields})
	  if (sectionAsChildrenNodes.includes(node?.tag) === true) {
		const children = sections?.filter(s => s.parent[0].id == node.uuid)
  
		node.children = []
		children.forEach(c => {
		  c.children = []
		  c.children.push(findChildrenNodes(c, sections, fields))
		})
		node.children = children
  
  
	  }
	  if (fieldAsChildrenNodes.includes(node?.tag) === true) {
		const children = fields?.filter(s => s.parent[0].id == node.uuid)
		node.children = []
		children.forEach(c => {
		  c.children = []
		  c.children.push(findChildrenNodes(c, sections, fields))
		})
		node.children = children
	  }
	  if (node?.tag === "field") {
		const children = fields?.filter(s => s.parent[0].id == node.uuid)
		node.children = []
		children.forEach(c => {
		  c.children = []
		  c.children.push(findChildrenNodes(c, sections, fields))
		})
		if (children.length > 0) {
		  node.children = children
		} else {
		  delete node.children
		}
	  }
	  return node;
  
	} catch (err) {
	  console.error(err)
	}
  }

const displayTypesInviews = [...otherDisplayTypes,{title: 'Image Map', value: 'image-map'}, {title: 'String', value: 'string'}].map(item => item.value);


//  To find the children of clusterlet
export const findClusterletChildren = (constructs) => {
	try {
		let availableConstructs = JSON.parse(JSON.stringify(constructs))

		const Dts = availableConstructs.clusterlets.filter(clusterlet => {
			if (clusterlet.type === 2 ) {
			  clusterlet.tag = "clusterlet"
			  clusterlet.uuid = clusterlet._id;
	  
			  delete clusterlet.id
			  delete clusterlet._id
			  delete clusterlet.type
			  delete clusterlet.position
			  if (clusterlet.profile) delete clusterlet.profile
	  
			  delete clusterlet.blueprint_id;
			  delete clusterlet.createdAt;
			  delete clusterlet.updatedAt;
			  delete clusterlet.__v;
			  return clusterlet
			}
		  })
	  
		const analytics = availableConstructs.clusterlets.filter(clusterlet => {
		if (clusterlet.type === 3) {
			clusterlet.tag = "clusterlet"
			clusterlet.attributes.type = clusterlet.attributes.type == 'infer_engine' ? 'infer_engine' : clusterlet.attributes.type == 'learn_engine' ? 'learn_engine' : clusterlet.attributes.type == 'generate_engine' ? 'generate_engine' : "analytics"
			// clusterlet.uuid = clusterlet.id
			clusterlet.uuid = clusterlet._id
			if (clusterlet.attributes?.cloneable) clusterlet.attributes.cloneable = String(clusterlet.attributes.cloneable) == "true"
			if (clusterlet.attributes?.collection) clusterlet.attributes.collection = String(clusterlet.attributes.collection) == "true"
	
			delete clusterlet._id
			delete clusterlet.type
			delete clusterlet.position
			if (clusterlet.profile) delete clusterlet.profile
	
			if (clusterlet.blueprint_id) delete clusterlet.blueprint_id;
			if (clusterlet.createdAt) delete clusterlet.createdAt;
			if (clusterlet.updatedAt) delete clusterlet.updatedAt;
			if (clusterlet.__v) delete clusterlet.__v;
	
			return clusterlet
		}
		})

		const fields = availableConstructs.fields?.map(field => {
			field.tag = "field"
			field.uuid = field._id
			field.viewCopy = true;
		
			delete field.id
			delete field.type
			delete field.children
			if (field.attributes?.collection) field.attributes.collection = String(field.attributes.collection) == "true"
			if (field.attributes?.optional) field.attributes.optional = String(field.attributes.optional) == "true"
			if ((JSON.stringify(field.attributes.event))?.length > 0) field.attributes.event = availableConstructs.events.find(event => event._id === field.attributes.event)?.name
		
			//fix for small double
			// if (field.attributes?.type && field.attributes?.type == 'double') field.attributes.type = 'DOUBLE'
		
		
			if (field.blueprint_id) delete field.blueprint_id
			if (field.createdAt) delete field.createdAt;
			if (field.updatedAt) delete field.updatedAt;
			if (field.__v) delete field.__v;
		
			return field
		})
	
		const sections = availableConstructs.sections?.map(section => {
			section.tag = "section"
			section.uuid = section._id
			section.viewCopy = true;

			delete section.id
			delete section.type
			delete section.children
		
			if (section.blueprint_id) delete section.blueprint_id
			if (section.createdAt) delete section.createdAt;
			if (section.updatedAt) delete section.updatedAt;
			if (section.__v) delete section.__v;
		
			return section
		})

		const clusterlets = [...Dts, ...analytics];


		let clusterletsAndChildren = clusterlets?.map(clusterlet => {
			const elementAndChildren = findChildrenNodes(clusterlet, sections, fields)
			return elementAndChildren
		})

		clusterletsAndChildren?.forEach(clusterlet => {
			deletePropertyRecursivly({ node: clusterlet, key: "parent" })
		})


		return clusterletsAndChildren;
	} catch (error) {
		console.error(`Error while finding clusterlet children. ${error}`);
		return null;
	}

}

export const formatClusterletFieldTypesOnMapping = (type, parentType) => {
	try {
		let newType = type;
		if(stringTypes.includes(type) && parentType === "struct"){
			newType = 'string';
		}else if(counterTypes.includes(type) && parentType === "struct"){
			newType = 'counter';
		}else{
			console.log("no type change")
		}
		return newType;

	} catch (error) {
		console.error(`Formatting clusterlet field type failed. ${error}`);
		return type ;
	}

}

export const formatClusterletFields = (children = [], parentType) => {
  try {
	const widgetDefaultChildren = uiTypeChildren();

    function formatSchema(fields, parentFieldType) {
      if (!Array.isArray(fields)) return [];

      return fields.map(field => {
        try {
          const formattedType = formatClusterletFieldTypesOnMapping?.( field?.attributes?.type, parentFieldType ) || field?.attributes?.type || "unknown";

          const baseDimensions = defaultDimensions?.[formattedType] || {};

          const newObj = {
            id: field?._id ?? "",
            name: field?.name ?? "",
            type: formattedType,
            desc: field?.attributes?.desc ?? "",
            infotype: formattedType === "counter" ? "numeric" : "info",
            title: field?.title || field?.name || "",
            category:
              formattedType === "struct" ? "section"
                : displayTypesInviews?.includes(formattedType) &&
                  ![...(displayTypesInviews || []), "table"].includes(
                    parentFieldType
                  )
                ? "ui" : field?.tag || "",
            dimensions: field?.dimensions || field?.attributes?.dimensions || baseDimensions,
            visible: true,
            viewCopy: true,
            children: [],
          };

          // Merge attributes without overwriting core fields
          if (field?.attributes) {
            Object.entries(field.attributes).forEach(([k, v]) => {
              if (!(k in newObj)) {
                newObj[k] = v;
              }
            });
          }

          // Recursively format children
          if ( Object.keys(widgetDefaultChildren)?.includes(formattedType) && Array.isArray(field?.children) && field.children.length > 0) {
            newObj.children = formatSchema(field.children, formattedType);
          }

		  if(formattedType === "table"){
			newObj.children = [...newObj.children, ...widgetDefaultChildren["table"]]
		  }

          return newObj;
        } catch (err) {
          console.error("Failed formatting field:", field, err);
          return null;
        }
      }).filter(Boolean);
    }

    return formatSchema(children, parentType);
  } catch (error) {
    console.error(`formatClusterletFields failed:`, error);
    return [];
  }
};

export const findChildrenForMapping = (levels, item) => {

	const selectedLevel = levels?.find(level => level.name === item)
  
	return {
		children: selectedLevel?.children,
		selectedLevel
	}
  
  }


//   This function is for updating shema with the modified properties for the view copy of a mapped children
export const updateMappingChildrenWithModifiedProperties = ({extensions, schema}) => {
	try {
	const formattedSchema = JSON.parse(JSON.stringify(schema));
	const formattedExtensions = JSON.parse(JSON.stringify(extensions));
	const modifiedFieldIds = formattedExtensions?.map(item => item?.parent)

	const updateSchema = (schemas=[]) => {
		try {
			const newSchema = schemas?.map(item => {
				const order = item?.order ? item?.order : "";

				let itemSchema  = {...item}; 
				if(modifiedFieldIds.includes(itemSchema?.id)){
					const attributes = formattedExtensions?.find(ex => ex.parent === itemSchema?.id)?.attributes;
					if(attributes !== undefined){
						itemSchema = {
							id: itemSchema?.id,
							name: itemSchema?.name,
							viewCopy: true,
							...attributes
						}

						if(order !== ""){
							// console.log("order exist in the org item")
							itemSchema.order = order
						}
					}
				}
				if(itemSchema?.children &&  itemSchema?.children?.length > 0){
					itemSchema.children = updateSchema(itemSchema.children)
				}
				
				return itemSchema
			})
			return newSchema;
		} catch (error) {
			console.error(`Updating schema failed. ${error}`);
			return [];
		}
	}
	return updateSchema(formattedSchema);

	} catch (error) {
		console.error(`Updating mapping children with modified properties failed. ${error}`);
		return schema;
	}
  }

export const formatSchemaWithMappingChild = ({ schema, clusterlets, transactions }) => {
	// console.log("---------------------formatSchemaWithMappingChild-----------------")
	try {
		const schemaSections = JSON.parse(JSON.stringify(schema));
	
		const updateSchema = (item) => {
			for (var i = 0; i < item.length; i++) {
				// console.log("MappingChild item-----------", item[i]?.name)
				// console.log(item[i])

				let itemWithoutChild = ['string', 'BOOL', 'DateTime', 'double', 'FLOAT', 'INT16', 'INT32', 'INT64', 'INT8', 'OCTETSTRING', 'TimeStamp', 'UINT32', 'UINT16', 'UINT64', 'UINT8']
				
				if ((!itemWithoutChild.includes(item[i]?.type)) && item[i]?.mapping !== undefined && item[i]?.mapping?.source == 'transaction' && !transactions.map(tr => tr._id.toString()).includes(item[i]?.mapping?.transaction)) {
					console.log("mapping present for item")
					let matchingClusterlet = clusterlets.find(cl => cl.uuid == item[i]?.mapping?.transaction);
					
					if (matchingClusterlet !== undefined) {
						console.log("matchingClusterlet found")

						let schemaItemChildrenNames = item[i]?.children?.map(item => item.name) || [];
			
						let fieldChildren = matchingClusterlet.children;
						

						// Finding the children of mapped item
						let selectedItem = '';
						if (item[i]?.mapping?.field != undefined) {
							let mappingFiled = item[i]?.mapping?.field;
							const splittedItems = mappingFiled.split('.');
							splittedItems.forEach(item => {
								const { selectedLevel, children } = findChildrenForMapping(fieldChildren, item)
								fieldChildren = children
								selectedItem = selectedLevel
							})
						}

						
						// filtering out the fields with same name that is present in the schema item children
						if(fieldChildren && fieldChildren?.length > 0 ){
							let sortedFieldChildren = sortClusterletFields(fieldChildren || []);
							console.log({sortedFieldChildren})

							if(schemaItemChildrenNames?.length > 0){
								console.log("updating order for the existing fields: ", schemaItemChildrenNames?.join(", "))
								console.log("current children: ", item[i]?.children)
								item[i].children = item[i]?.children?.map(child => {
									const field = sortedFieldChildren?.find(f => f?.name === child?.name);
									if(field && field?.order){
										child.order = field?.order;
									}
									return child;
								})
								console.log({"updated children": item[i]?.children})

								fieldChildren = sortedFieldChildren?.filter(item => !schemaItemChildrenNames?.includes(item?.name));
							}
						}
						// console.log("final children to be copied: ", fieldChildren)


						/**
							 * if mapped item is a section, we copy only ui types and their nested children as children of item
							 * we also copy only visible true elements
						 */
						if (fieldChildren && fieldChildren?.length>0 && selectedItem?.tag === 'section') {
							fieldChildren = fieldChildren?.filter(item => item?.attributes?.visible !== false)
						}
			
						if (fieldChildren && fieldChildren?.length > 0) {
							let formattedChildren = formatClusterletFields(fieldChildren, item[i]?.type);
			
							// Update the field children with modified properties
							if(item[i]?.mapping?.extensions && item[i]?.mapping?.extensions.length > 0){
								console.log("extendd props found")
								formattedChildren = updateMappingChildrenWithModifiedProperties({extensions: item[i].mapping?.extensions, schema: formattedChildren})
							}

							item[i].children = [...item[i].children, ...formattedChildren]; 
							// console.log("merged children: ", item[i]?.children)

							// if (item[i]?.type == 'table') {
							// }
							item[i].children = JSON.parse(JSON.stringify(item[i].children))?.sort((a, b) => a?.order - b?.order) // sorting the table fields based on the order 
							// console.log("merged children sorted: ", item[i]?.children)
							
						}
		
		
					} 
				}
		
				if (item[i].children) updateSchema(item[i].children)
	
			}
	
	
			return item
	
		}
	
		const updatedSchema = updateSchema(schemaSections)
		return updatedSchema
  
	} catch (error) {
		console.error(`Format schema with mapping child failed. ${error}`);
		return schema;
	}
  
  }

//   This function is for filtering out the 'view copy' of clusterlet mapped items from the view schema, since those item are not saving to DB
export const filterViewSchemaWhileSaving = (schema) => {
	try {
	

	const filterSchema = (itemSchema) => {
		// console.log("filterSchema---------", itemSchema)
		const newSchema = itemSchema?.filter(item => {
			// console.log("item: ", item?.name)
		
			if(item?.children != undefined && item?.children.length > 0){
				item.children = filterSchema(item?.children)
			}
		
			if(item?.viewCopy == undefined){
				// console.log("not copied item")
				return item;
			}
		})
		return newSchema;
	}

	const updatedSchema = filterSchema(schema) 
	

	return updatedSchema;

			
	} catch (error) {
		console.error(error);
		return schema;
	}
}

export const findClusterletMappedParentID = ({schema, selectedItem, parentID, clusterlets}) => {
	// console.log("-------findClusterletMappedParent---------")
	// console.log("schema: ", schema)
	// console.log("selectedItem: ", selectedItem)
	// console.log("parentID: ", parentID)
	const clusterletIds = clusterlets?.map(item => item?._id)
	// console.log("clusterletids: ", clusterletIds)


	const flattenSchemaItems = flattenSchema(schema) 
	// console.log("flatten schema: ", flattenSchemaItems)

	
	let mappedParentID = "";
	let selectedItemId = selectedItem?.id;
	if(selectedItemId != undefined ){
		flattenSchemaItems?.forEach( _item => {
	
			let parentInfo = findImmediateParent(schema, selectedItemId) 
			let parentData = flattenSchemaItems?.find(item => item?.id == parentInfo?.id)
	
			if( parentData != undefined  ){
				// console.log("parentData: ", parentData)	
				selectedItemId = parentInfo?.id
				
				if(parentData?.mapping?.transaction != undefined && clusterletIds?.includes(parentData?.mapping?.transaction)){
					// console.log("--clusterlet mapping exist for the parent--")
					mappedParentID = parentData?.id
					return
				}
						
			}else{
				return
			}  
		})
	}

	return mappedParentID;

}

const flattenSchema = (schema) => {
	function flatten(array, currentArray) {
		if (!array) return currentArray;

		return [...array.flatMap((currentElement) => {
			const { children, ...element } = currentElement;
			return [{ children, ...element }, ...flatten(children, [])];
		}), ...currentArray];
	}

	const sections = flatten(schema, [])

	return sections;
}

export const sortClusterletFields = (fields) => {
	try {
		const sortFields = (children) => {
			let updatedFields = children?.sort((a, b) => a?.order - b?.order)

			updatedFields = updatedFields?.map(field => {
				if(field?.children && field?.children?.length > 0){
					field.children = sortFields(field?.children);
				}		
				return field;
			})
			
			
			return updatedFields;
		}

		const sortedFields = sortFields(fields)

		return sortedFields;
	} catch (error) {
		console.error("Sorting clusterlet children fields failed. ", error);
		return fields;
	}
}


export const getMessageWithChildren = ({fields, messages}) => {
	try {
		const updatedMessages = messages?.map(message => {
			const children = findChildrenForMessage({message, fields});
			message.children = children || [];
			return message;
		})

		return updatedMessages;

	} catch (error) {
		console.error(error);
		return messages;
	}
}

export const flattenArray = (arr) => {
	try {
		return arr.reduce((flat, item) => {
			flat.push({...item, children: []}); // Add item without children
			
			// If children exist, recursively flatten them and add to the result
			if (item.children && item.children.length > 0) {
				flat = flat.concat(flattenArray(item.children));
			}
			return flat;
		}, []);
		
	} catch (error) {
		console.error(error);
		return arr;
	}
}

export const findChildrenForMessage = ({message, fields}) => {
	try {
		
		const findChildren = ({parent, fields}) => {
			const children = fields?.filter(field => field?.parent[0]?.id === parent) || []
			children.map(field => {
				field.children = findChildren({parent: field._id.toString(), fields}) || [];
				return field;
			})
			return children; 
		}


		const children = findChildren({parent: message?._id.toString(), fields}) || [];
		return children ;


	} catch (error) {
		console.error(error);
		return [];
	}
}


export const isParentMappedFromClusterlet = ({schema, parentID, clusterlets}) => {

}
